export const BENCHMARK_LEADS_PATH = '/pga-coach/leads'

export const COACH_BENCHMARKS_PATH = '/pga-coach/benchmarks'
export const BENCHMARK_METRIC_QUERY_PARAM = 'metric'

export const getCoachBenchmarksPath = (metricId = null) =>
  metricId
    ? `${COACH_BENCHMARKS_PATH}?${BENCHMARK_METRIC_QUERY_PARAM}=${metricId}`
    : COACH_BENCHMARKS_PATH

export const getMetricCalculationDescription = metric =>
  metric.calculationDescription ?? metric.description

export const parseBenchmarkMetricId = search =>
  new URLSearchParams(search).get(BENCHMARK_METRIC_QUERY_PARAM)

export const COACH_DASHBOARD_PATH = '/pga-coach'

export const BENCHMARK_PEER_LABEL = 'Top coaches'

export const TOP_COACHES_DIALOG_TITLE = 'How we define top coaches'
export const TOP_COACHES_DIALOG_SUBTITLE =
  'What the top coaches comparison is based on.'

const TOP_COACHES_PERCENTILE = '85th'
const TOP_COACHES_WINDOW = '12 months'

export const getTopCoachesDefinition = cohortSize =>
  `are the ${
    cohortSize ? `${cohortSize} ` : ''
  }PGA Coach coaches at or above the ${TOP_COACHES_PERCENTILE} percentile of lesson revenue over the last ${TOP_COACHES_WINDOW}.`

// Each item is a fact shown as its own row in the definition dialog. The
// dialog maps `id` to an icon.
export const TOP_COACHES_DETAILS = [
  {
    id: 'lesson-revenue',
    label: 'What lesson revenue includes',
    description:
      'Lesson revenue is what coaches take home from lessons and lesson packs booked on PGA Coach, after refunds. It leaves out PGA fees, taxes, payment processing, and Coach+ subscription payments. Lessons and payments outside PGA Coach are not counted.',
  },
  {
    id: 'nationwide',
    label: 'Nationwide, not regional',
    description:
      'Every coach is compared with the same nationwide group of top coaches. The group is not based on your region or section.',
  },
  {
    id: 'medians',
    label: 'Medians, anonymized',
    description:
      'Each top coaches figure is the median for that group, so about half of top coaches are above it and half are below. Figures are anonymized, and no individual coach is identified.',
  },
  {
    id: 'snapshot',
    label: 'A fixed snapshot',
    description:
      'The group comes from a fixed snapshot of PGA Coach data. It is not recalculated each time you visit.',
  },
]

export const getTopCoachesDefinitionItem = cohortSize => ({
  id: 'top-coaches',
  label: 'Who counts as top coaches',
  description: `Top coaches ${getTopCoachesDefinition(cohortSize)}`,
})

// Headline numbers for the dialog callout. The cohort tile is skipped when the
// backend has not published a cohort size.
export const getTopCoachesStats = cohortSize => [
  {
    id: 'percentile',
    value: TOP_COACHES_PERCENTILE,
    label: 'percentile or above',
  },
  ...(cohortSize
    ? [{ id: 'cohort', value: String(cohortSize), label: 'PGA Coach coaches' }]
    : []),
  { id: 'window', value: TOP_COACHES_WINDOW, label: 'of lesson revenue' },
]
